import { useEffect, useState } from "react";
import { localApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { X, Info, Warning, Tag, Wrench } from "@phosphor-icons/react";

const STYLES = {
  info: { cls: "border-sky-500/30 bg-sky-500/10 text-sky-600 dark:text-sky-400", icon: Info },
  warning: { cls: "border-amber-500/30 bg-amber-500/10 text-amber-600 dark:text-amber-400", icon: Warning },
  promo: { cls: "border-primary/40 bg-primary/10 text-primary", icon: Tag },
  maintenance: { cls: "border-red-500/30 bg-red-500/10 text-red-600 dark:text-red-400", icon: Wrench },
};

export default function Announcements() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);

  useEffect(() => {
    localApi
      .get("/announcements/active")
      .then((r) => {
        const unread = (r.data || []).filter((a) => !a.read);
        setItems(unread.filter((a) => a.show_as !== "modal"));
        const m = unread.find((a) => a.show_as === "modal");
        if (m) setModal(m);
      })
      .catch(() => {});
  }, []);

  const dismiss = async (a) => {
    setItems((prev) => prev.filter((i) => i.id !== a.id));
    if (modal?.id === a.id) setModal(null);
    try { await localApi.post(`/announcements/${a.id}/read`); } catch { /* silencioso */ }
  };

  if (items.length === 0 && !modal) return null;

  return (
    <>
      {items.map((a) => {
        const st = STYLES[a.type] || STYLES.info;
        const Icon = st.icon;
        return (
          <div key={a.id} className={`border rounded-sm px-4 py-3 mb-4 flex items-start gap-3 ${st.cls}`} data-testid={`announcement-${a.id}`}>
            <Icon size={18} className="shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold text-foreground">{a.title}</p>
              <p className="text-sm text-foreground/80 mt-0.5 whitespace-pre-line">{a.content}</p>
              {a.link_url && (
                <a href={a.link_url} target="_blank" rel="noreferrer" className="text-sm underline underline-offset-2 mt-1 inline-block" data-testid={`announcement-link-${a.id}`}>
                  {a.link_label || "Más información"}
                </a>
              )}
            </div>
            <button onClick={() => dismiss(a)} className="shrink-0 text-muted-foreground hover:text-foreground transition-colors" data-testid={`announcement-close-${a.id}`} aria-label="Cerrar aviso">
              <X size={16} />
            </button>
          </div>
        );
      })}

      <Dialog open={!!modal} onOpenChange={() => modal && dismiss(modal)}>
        <DialogContent aria-describedby={undefined} className="bg-card border-border rounded-sm sm:max-w-md" data-testid="announcement-modal">
          <DialogHeader>
            <DialogTitle className="font-heading text-foreground">{modal?.title}</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-foreground/80 whitespace-pre-line">{modal?.content}</p>
          <DialogFooter>
            <Button onClick={() => modal && dismiss(modal)} className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/80" data-testid="announcement-modal-ok">
              Entendido
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
